import { get } from '.';

const cache: Record<string, boolean> = {};

export function clearFeatureFlagCache(): void {
	Object.keys(cache).forEach(k => delete cache[k]);
}

export async function CheckFeatureFlag(key: string): Promise<boolean> {
	if (!key) {
		return false;
	}
	if (key in cache) {
		return cache[key];
	}
	const response = await get<{ enabled: boolean }>('/app/api/feature_flags/check', { key });
	const enabled = response?.Data?.enabled === true;
	cache[key] = enabled;
	return enabled;
}
